export default function Cookies() {

  return (

    <div className="container-narrow">

      <div className="card">

        <h1>Cookie Policy</h1>

        <p>

          Hopeful Horizons NY may use cookies or similar technologies to improve user experience, maintain secure sessions, and analyze site usage.

        </p>

        <p>

          Cookies help ensure the website functions properly and allow improvements based on usage patterns.

        </p>

        <p>

          Users may disable cookies through browser settings, though some features of the site may not function properly.

        </p>

      </div>

    </div>

  );

}